import { CreateHTMLSpinner } from "./CreateHTMLSpinner";

export function AddHTMLSpinner(textStr = "") {
  var spinnerPad = document.createElement("container");
  spinnerPad.setAttribute("class", "spinner-container oc-dark-transparent-bg");
  spinnerPad.setAttribute("id", "spinner-pad");
  spinnerPad.style.zIndex = "40";

  var spinner = CreateHTMLSpinner();

  spinnerPad.append(spinner);

  var spinnerText = document.createElement("span");
  spinnerText.setAttribute("class", "spinner-text");
  spinnerText.setAttribute("id", "spinner-text");
  spinnerText.innerText = textStr;
  spinnerPad.append(spinnerText);

  const root = document.getElementById("modal-root") ?? document.body;

  root.appendChild(spinnerPad);

  return spinnerPad;
}
